/**
 * Search Suggestion Types for v2v2 SWFL Farmers Market Application
 * Defines the structure for autocomplete search suggestions
 */

export type SuggestionType = 
  | 'product' 
  | 'category' 
  | 'vendor' 
  | 'market' 
  | 'recent' 
  | 'seasonal';

export interface SearchSuggestion {
  id: string;
  text: string;
  type: SuggestionType;
  relevance: number;
  category?: string;
  location?: string;
  icon?: string;
  seasonalNote?: string;
  highlightRanges?: [number, number][]; // Character ranges to highlight
}

export interface SuggestionGroup {
  title: string;
  icon: string;
  suggestions: SearchSuggestion[];
}

export interface UseSuggestionsReturn {
  suggestions: SuggestionGroup[];
  isLoading: boolean;
  selectedIndex: number;
  setSelectedIndex: (index: number) => void;
  onSelect: (suggestion: SearchSuggestion) => void;
  addRecentSearch: (query: string) => void;
  clearRecentSearches: () => void;
  recentSearches: string[];
}

export const SUGGESTION_LIMITS = {
  products: 3,
  categories: 2,
  vendors: 2,
  markets: 2,
  recent: 3,
  seasonal: 3,
  total: 10,
};

export const SUGGESTION_ICONS: Record<SuggestionType, string> = {
  product: 'package',
  category: 'folder',
  vendor: 'store',
  market: 'map-pin',
  recent: 'clock',
  seasonal: 'leaf',
};

export const SUGGESTION_GROUP_TITLES: Record<SuggestionType, string> = {
  product: 'Products',
  category: 'Categories',
  vendor: 'Vendors',
  market: 'Markets',
  recent: 'Recent Searches',
  seasonal: 'In Season',
};
